import { UserSettingsCandidateFeedbackDefaults } from "./UserSettingsCandidateFeedbackDefaults"

export class UserSettingsFeatures {
  "U-enableReadSpeaker": boolean = false
  c_enableReadSpeaker: boolean = false
  candidateFeedbackDefaults: UserSettingsCandidateFeedbackDefaults = new UserSettingsCandidateFeedbackDefaults()
  enableCustomItemIntroductionText: boolean = false
  enableKeyApproving: boolean = false
  enableNda: boolean = false
  enableProctorio: boolean = false
  enableExternalIdForAssessments: boolean = false
  enableExternalIdForSchedules: boolean = false
  enableExternalIdForReviewSessions: boolean = false
  enableVpl: boolean = false
  externalApi: boolean = false
  sowiso: boolean = false
  wiris: boolean = false
}
